import { useAuth0 } from '@auth0/auth0-react';
import { useImpersonation } from './useImpersonationStore';

export function useIsImpersonationOn() {
  const { user } = useAuth0();
  const { impersonatedUser } = useImpersonation();

  return user?.name === 'admin@mediainbox.io' && !!impersonatedUser;
}
